var _g, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSideStatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5C19.1421 22.5 22.5 19.1421 22.5 15C22.5 10.8579 19.1421 7.5 15 7.5C10.8579 7.5 7.5 10.8579 7.5 15C7.5 19.1421 10.8579 22.5 15 22.5Z",
    fill: "url(#paint0_linear_2_37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5C19.1421 22.5 22.5 19.1421 22.5 15C22.5 10.8579 19.1421 7.5 15 7.5C10.8579 7.5 7.5 10.8579 7.5 15C7.5 19.1421 10.8579 22.5 15 22.5Z",
    fill: "url(#paint1_linear_2_37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5C19.1421 22.5 22.5 19.1421 22.5 15C22.5 10.8579 19.1421 7.5 15 7.5C10.8579 7.5 7.5 10.8579 7.5 15C7.5 19.1421 10.8579 22.5 15 22.5Z",
    fill: "url(#paint2_linear_2_37)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.68341 16.9299L17.542 2.69967C17.8704 2.30555 18.5085 2.60261 18.4183 3.10765L16.7857 12.25H23.9325C24.3564 12.25 24.588 12.7444 24.3166 13.0701L12.646 27.0747C12.306 27.4828 11.6485 27.1493 11.7767 26.6339L13.9881 17.75H6.06752C5.6436 17.75 5.41202 17.2556 5.68341 16.9299Z",
    fill: "black",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6627 12.228L16.6364 12.375H16.7857H23.9325C24.2504 12.375 24.4241 12.7458 24.2206 12.9901L12.55 26.9947C12.295 27.3007 11.8018 27.0506 11.898 26.6641L14.1094 17.7802L14.148 17.625H13.9881H6.06753C5.74959 17.625 5.57591 17.2542 5.77945 17.0099L17.638 2.77969C17.8843 2.4841 18.3629 2.7069 18.2952 3.08568L16.6627 12.228Z",
    stroke: "url(#paint3_linear_2_37)",
    strokeOpacity: 0.1,
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2_37",
    x: 5.56657,
    y: 2.51781,
    width: 18.8669,
    height: 25.2393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_37",
    x1: 8.125,
    y1: 10.5,
    x2: 24.4762,
    y2: 12.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_37",
    x1: 7.5,
    y1: 15.005,
    x2: 22.5,
    y2: 15.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A91B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_37",
    x1: 21.58,
    y1: 22.0841,
    x2: 5.72792,
    y2: 4.66263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5961DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#434DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F46B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_37",
    x1: 5.62501,
    y1: 2.50001,
    x2: 25,
    y2: 2.50001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD84DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD6FA"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideStatic);
export default __webpack_public_path__ + "static/media/side-static.1a13d505f4b1e204387218275dc7f60c.svg";
export { ForwardRef as ReactComponent };